import {FC, useState} from 'react'

import {TeamCategory} from '@/content/team'
import {getTeamContent} from '@/content/teamContent'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

import {Tab} from '../content/tabs/Tab'
import {Tabs} from '../content/tabs/Tabs'
import {TeamCarousel} from './TeamCarousel'
import {TeamMember} from './TeamMember'

export const TeamCategoryTabs: FC = () => {
  const {t} = useTranslation()
  const {team} = getTeamContent()
  const [activeCategory, setActiveCategory] = useState<TeamCategory>(TeamCategory.highlighted)

  const teamMembers = team[activeCategory].teamMembers

  return (
    <>
      <div className="tabs">
        <Tabs isCentered>
          {Object.entries(team).map(([key, {title}]) => (
            <Tab
              key={key}
              title={t(title)}
              isActive={key === activeCategory}
              onClick={() => setActiveCategory(key as TeamCategory)}
            />
          ))}
        </Tabs>
      </div>
      <div className="desktop">
        <div className="team">
          {teamMembers.map((teamMember) => (
            <TeamMember key={teamMember.name} teamMember={teamMember} />
          ))}
        </div>
      </div>
      <div className="mobile">
        <TeamCarousel teamMembers={teamMembers} />
      </div>

      <style jsx>{`
        .tabs {
          margin-top: ${theme.spacing[7]};
        }
        .mobile {
          display: none;
        }
        .team {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
          grid-gap: ${theme.spacing[5]};
          margin-top: ${theme.spacing[7]};
        }
        @media ${TABLET_SCREENSIZE} {
          .team {
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .desktop {
            display: none;
          }
          .mobile {
            display: block;
          }
          .tabs {
            margin-top: ${theme.spacing[5]};
          }
        }
      `}</style>
    </>
  )
}
